import { ca } from '@cian/analytics';

// OK
export const trackAddressInputSelect = (adAnalyticsCategory) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'GEO',
    label: 'address_input_select',
  });
};

export const trackHighwayAdd = (highwayId, adAnalyticsCategory) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'GEO',
    label: ['add_highway', highwayId].join('/'),
  });
};

export const trackUndergroundAdd = (metroId, adAnalyticsCategory) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'GEO',
    label: ['add_metro', metroId].join('/'),
  });
};

export const trackHighwayDistanceChange = (adAnalyticsCategory) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'GEO',
    label: 'change_highway_distance',
  });
};

export const trackUndergroundDistanceChange = (adAnalyticsCategory) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'GEO',
    label: 'change_metro_distance',
  });
};
